/*! bxs-vue-ui v4.0.1 */
import { i as indexOf } from '../utils/es.array.join.js';
import { c as create, n as normalizeComponent } from '../utils/normalize-component.js';
import { j as splice } from '../utils/index.js';
import { s as slice } from '../utils/slice.js';
import 'vue';
import '../utils/concat.js';
import __vue_component__$1 from '../icon/index.js';

var _components;

var onlyValues = function onlyValues(values) {
  return function (str) {
    return indexOf(values).call(values, str) !== -1;
  };
};

var script = create({
  name: 'checkbox',
  components: (_components = {}, _components[__vue_component__$1.name] = __vue_component__$1, _components),
  props: {
    name: null,
    shape: {
      type: String,
      default: 'round',
      validator: onlyValues(['round', 'square'])
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkedColor: String
  },
  data: function data() {
    return {
      parent: null
    };
  },
  computed: {
    checked: {
      get: function get() {
        var _context;

        return this.parent ? indexOf(_context = this.parent.value).call(_context, this.name) !== -1 : this.value;
      },
      set: function set(val) {
        if (this.isDisabled) {
          return;
        }

        if (this.parent) {
          this.setParentValue(val);
        } else {
          this.$emit('input', val);
        }
      }
    },
    isDisabled: function isDisabled() {
      return this.parent ? this.parent.disabled || this.disabled : this.disabled;
    },
    iconStyle: function iconStyle() {
      var checkedColor = this.checkedColor,
          checked = this.checked;

      if (checkedColor && checked) {
        return {
          borderColor: checkedColor,
          backgroundColor: checkedColor
        };
      }

      return {};
    }
  },
  watch: {
    value: function value(val) {
      this.$emit('change', val);
    }
  },
  created: function created() {
    this.findParent('bxs-checkbox-group');
  },
  methods: {
    toggle: function toggle() {
      this.checked = !this.checked;
    },
    setParentValue: function setParentValue(val) {
      var _context2;

      var parent = this.parent;

      var value = slice(_context2 = parent.value).call(_context2);

      if (val) {
        if (parent.max && value.length >= parent.max) {
          return;
        }

        if (indexOf(value).call(value, this.name) === -1) {
          value.push(this.name);
          parent.$emit('input', value);
        }
      } else {
        var index = indexOf(value).call(value, this.name);

        if (index !== -1) {
          splice(value).call(value, index, 1);

          parent.$emit('input', value);
        }
      }
    },
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          this.parent = parent;
          break;
        }

        parent = parent.$parent;
      }
    }
  }
});

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "bx-checkbox"
  }, [_c('div', {
    class: ['bx-checkbox-icon', "bx-checkbox-" + _vm.shape, {
      'bx-checkbox-checked': _vm.checked
    }, {
      'bx-checkbox-disabled': _vm.isDisabled
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("icon", [_c('bxs-icon', {
    style: _vm.iconStyle,
    attrs: {
      "name": "check",
      "size": "12px"
    }
  })], {
    checked: _vm.checked
  })], 2), _vm.$slots.default ? _c('span', {
    class: ['bx-checkbox-label', {
      'bx-checkbox-disabled': _vm.isDisabled
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;
